import React from 'react'
import { Grid,Paper, Avatar, TextField, Button } from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import axios from 'axios';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
const urlById = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/medicalteam/find/id";
   
const LoginMedic=(props)=>{

    const paperStyle={padding :20,height:'70vh',width:280, margin:"20px auto"}
    const avatarStyle={backgroundColor:'#1bbd7e'}
    const btnstyle={margin:'8px 0'}
    const [msgError, setMsgError] = React.useState("");
    const [info, setInfo] = React.useState({id: '', password: ''});
    const [openLoader, setOpenLoader] = React.useState(false);
    const handleChange = e => {
        setMsgError("");
        setInfo({
            ...info,
            [e.target.name]: e.target.value
        })
    }
    const logIn = () => {
        /*if(info.id != info.password){
            setMsgError("usuario o contraseña incorrecto");
            return;
        }*/
        setOpenLoader(true);
        axios.post(urlById, info).then(response => { 
            setOpenLoader(false);
            //console.log("respuesta logueo:  " + JSON.stringify(response.data));
            if (response.data == null || response.data == "" || response.data.password != info.password) {
                setMsgError("usuario o contraseña incorrecto");
                return;
            }
            props.setLogged(true);
            props.setUser(response.data)
        });

    }
    return(
        <div>
        <Grid>
            <Paper elevation={10} style={paperStyle}>
                <Grid align='center'>
                     <Avatar style={avatarStyle}><LockOutlinedIcon/></Avatar>
                    <h2>Bienvenido</h2>
                </Grid>
                <TextField onChange={handleChange} value={info.id} name={"id"} label='Usuario' placeholder='Enter username' fullWidth required/>
                <TextField onChange={handleChange} value={info.password} name={"password"}label='Contraseña' placeholder='Enter password' type='password' fullWidth required/>
                <Typography>{msgError}</Typography>
                
                <Button onClick={logIn} type='submit' color='primary' variant="contained" style={btnstyle} fullWidth>Ingresar</Button>
              
               
            </Paper>
        </Grid>
          <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openLoader}>
          <CircularProgress color="inherit" />
            </Backdrop>
      </div>
    )
}

export default LoginMedic